// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","field":"field-2Xs_w","name":"name-3QHo8","input":"input-2jccR"};